import axios from "axios";
import EnvConfig from "../config/env.config.json";

const instance = axios.create({
  baseURL: EnvConfig.SHOPWARE_CUSTOM_URL,
  timeout: 30000,
});

export { instance as default };
